// Crown shop tab — meta-upgrades bought with ascend-earned crowns.
// State mutation (buyShopItem) lives in main.js; this is the panel.
import { render } from 'preact';
import { CROWN_SHOP_ITEMS } from '../content/crown-shop.js';
import { state } from '../systems/state.js';
import { useStore } from './use-store.js';

let onBuyShopItem = null;
export function initShop({ onBuyShopItemCb }) { onBuyShopItem = onBuyShopItemCb; }

function ShopSub() {
  useStore();
  return <span>you have {state.crowns || 0}👑 to spend.</span>;
}

function ShopList() {
  useStore();
  return (
    <>
      {CROWN_SHOP_ITEMS.map(item => {
        const owned = !!(state.crownShop && state.crownShop[item.id]);
        const affordable = (state.crowns || 0) >= item.cost;
        return (
          <div key={item.id} className={'ach-row' + (!owned && !affordable ? ' locked' : '')}>
            <div className="icon">{item.icon}</div>
            <div className="info">
              <div className="name">{item.name}</div>
              <div className="desc">{item.desc}</div>
            </div>
            <button
              className={'shop-buy' + (owned ? ' owned' : '')}
              disabled={owned || !affordable}
              onClick={() => onBuyShopItem(item.id)}
            >
              {owned ? 'owned' : item.cost + '👑'}
            </button>
          </div>
        );
      })}
    </>
  );
}

export function mountShop() {
  render(<ShopSub />, document.getElementById('shop-sub'));
  render(<ShopList />, document.getElementById('shop-list'));
}

